import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { ReactionCollection } from '../index'

export const setupReactionReplication = (
  collection: ReactionCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'reactions',
    displayName: 'Reaction',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      entityType: doc.entityType,
      entityId: doc.entityId,
      emoji: doc.emoji,
      emojiLabel: doc.emojiLabel ?? null,
      emojiShortcode: doc.emojiShortcode ?? null,
      userId: doc.userId,
      isDeleted: doc.isDeleted || false,
      userName: doc.userName,
      userEmail: doc.userEmail,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      entityType: state.entityType,
      entityId: state.entityId,
      emoji: state.emoji,
      emojiLabel: state.emojiLabel ?? null,
      emojiShortcode: state.emojiShortcode ?? null,
      userId: state.userId,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
